import React from "react";
import {useModalStore} from "@/Stores/Site/ModalStore";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import {Tab, Tabs} from "@/Components/Tabs";
import Picture from "@/Components/Picture";
import "@/Scss/Site/PlatinaBenefits/index.scss";

const Index = (props) => {
    const {authCheck = false, data = [], mobileApp = false} = props;
    const {
        mainImagePath = '',
        mainImageMobilePath = '',
        titleAdvantages = '',
        advantages = [],
        statuses = [],
        events = [],
    } = data;
    const {items = [], appsImage = '', appsTitle = '', appsDescription = '', appsButtonName = ''} = events;

    const openModalAuthOrRegister = useModalStore(state => state.openModalAuthOrRegister);

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    <div className={`platinaBenefits`}>
                        <div className={`platinaBenefits--mainImage`}>
                            {!mobileApp && (
                                <>
                                    {!authCheck && (
                                        <div onClick={openModalAuthOrRegister}>
                                            <Picture src={mainImagePath} srcMobile={mainImageMobilePath}
                                                     alt={`benefits`} />
                                        </div>
                                    )}
                                    {authCheck && (
                                        <Link href={`/home?profile=programClub`}>
                                            <Picture src={mainImagePath} srcMobile={mainImageMobilePath}
                                                     alt={`benefits`} />
                                        </Link>
                                    )}
                                </>
                            )}
                            {mobileApp && (
                                <Picture src={mainImagePath} srcMobile={mainImageMobilePath} alt={`benefits`} />
                            )}
                        </div>
                        <div className={`platinaBenefits--advantages`}>
                            <p className={`platinaBenefits--advantages__title`}>{titleAdvantages}</p>
                            <div className={`platinaBenefits--advantages__body`}>
                                {advantages.map(({id, iconPath = '', text = ''}) => {
                                    return (
                                        <div key={id} className={`platinaBenefits--advantages__item`}>
                                            <Picture src={iconPath} alt={text} />
                                            <p className={`platinaBenefits--advantages__itemText`}>{text}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={`platinaBenefits--statuses`}>
                            <Tabs>
                                {statuses.map((el, index) => {
                                    const {label = '', image = '', description = '', list = []} = el;
                                    return (
                                        <Tab key={index} label={label}>
                                            <div className={`platinaBenefits--statuses__item`}>
                                                <div className={`platinaBenefits--statuses__image`}>
                                                    <Picture src={image} alt={label} />
                                                </div>
                                                <div className={`platinaBenefits--statuses__content`}>
                                                    <p className={`platinaBenefits--statuses__description`}>
                                                        Статус <span
                                                        className={`statusName`}>{label}</span> {description}
                                                    </p>
                                                    <div className={`platinaBenefits--statuses__list`}>
                                                        {list.map((item) => {
                                                            const {id, text = ''} = item;
                                                            return (
                                                                <div key={id}
                                                                     className={`platinaBenefits--statuses__listItem`}>
                                                                    <p className={`platinaBenefits--statuses__listNumber`}>
                                                                        {id}
                                                                    </p>
                                                                    <p className={`platinaBenefits--statuses__listText`}>
                                                                        {text}
                                                                    </p>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab>
                                    );
                                })}
                            </Tabs>
                        </div>
                        <div className={`platinaBenefits--events`}>
                            {items.map(({id, image = '', title = '', description = ''}) => {
                                return (
                                    <div
                                        key={id}
                                        className={`platinaBenefits--events__item platinaBenefits--events__item_${id}`}>
                                        <p className={`platinaBenefits--events__itemTitle`}>{title}</p>
                                        <p className={`platinaBenefits--events__itemDescription`}>{description}</p>
                                        <Picture src={image} alt={title} />
                                    </div>
                                );
                            })}
                            {/*<div className={`platinaBenefits--events__apps`}>*/}
                            {/*    <div className={`platinaBenefits--events__appImage`}>*/}
                            {/*        <Picture src={appsImage} alt={appsTitle} />*/}
                            {/*    </div>*/}
                            {/*    <div className={`platinaBenefits--events__appContent`}>*/}
                            {/*        <p className={`platinaBenefits--events__appsTitle`}>{appsTitle}</p>*/}
                            {/*        <p className={`platinaBenefits--events__appsDescription`}>{appsDescription}</p>*/}
                            {/*        <a href={`https://platina.onelink.me/XKls/3h9xijzw`}*/}
                            {/*           className={`button button_install`}*/}
                            {/*           target={`_blank`}*/}
                            {/*           role={`button`}>*/}
                            {/*            {appsButtonName}*/}
                            {/*        </a>*/}
                            {/*        /!*<div className={`button button_install`}>{appsButtonName}</div>*!/*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                        <div className={`platinaBenefits--footer`}>
                            {!mobileApp && (
                                <>
                                    {!authCheck && (
                                        <p className={`button button_lk`} onClick={openModalAuthOrRegister}>
                                            Войти
                                        </p>
                                    )}
                                    {authCheck && (
                                        <Link href={`/home?profile=programClub`} className={`button button_lk`}>
                                            Личный кабинет программы
                                        </Link>
                                    )}
                                </>
                            )}
                            <p className={`platinaBenefits--footer__footnote`}>
                                *Списание бонусов на определенные товары в рамках специальных акций Организатора
                                Программмы может быть ограничено или невозможно. Более подробно с правилами бонусной
                                программы можно ознакомиться <Link href={`/platina-benefits-rules`}
                                                                   className={`platinaBenefits--footer__footnote platinaBenefits--footer__footnote_link`}>
                                здесь.</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
}

export default Index;
